import { render, staticRenderFns } from "./ModalSettings.vue?vue&type=template&id=2ae3289f&scoped=true&"
import script from "./ModalSettings.vue?vue&type=script&lang=ts&"
export * from "./ModalSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSettings.vue?vue&type=style&index=0&id=2ae3289f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae3289f",
  null
  
)

export default component.exports